module.exports = __webpack_public_path__ + "img/sticker.70a3d825.jpeg";